/* eslint-disable */
import { Product, productFromJSON, productToJSON } from "../../../sell/common/common";
import {
  SellerInput_Channel,
  sellerInput_ChannelFromJSON,
  sellerInput_ChannelToJSON,
} from "../../../sell/reception/data/seller_input";
import { Offer_State, offer_StateFromJSON, offer_StateToJSON } from "../../../sell/seller/data/offer";
import {
  SellerExperience,
  sellerExperienceFromJSON,
  sellerExperienceToJSON,
} from "../../../sell/seller/data/product_experience";

export const protobufPackage = "od_protos.journey.data.categories";

export interface SellCategory {
  event?:
    | { $case: "addressEntry"; addressEntry: SellCategory_AddressEntryEvent }
    | { $case: "apiOfferRequest"; apiOfferRequest: SellCategory_ApiOfferRequestEvent }
    | { $case: "apiReferralHandover"; apiReferralHandover: SellCategory_ApiReferralHandoverEvent }
    | { $case: "onboardingStart"; onboardingStart: SellCategory_OnboardingStartEvent }
    | { $case: "addressEntryV2"; addressEntryV2: SellCategory_AddressEntryV2Event }
    | { $case: "ssvaTaskComplete"; ssvaTaskComplete: SellCategory_SSVATaskCompleteEvent }
    | {
      $case: "customerProductIntentAtFinalOffer";
      customerProductIntentAtFinalOffer: SellCategory_CustomerProductIntentAtFinalOffer;
    }
    | {
      $case: "customerProductIntentPostFinalOffer";
      customerProductIntentPostFinalOffer: SellCategory_CustomerProductIntentPostFinalOffer;
    }
    | { $case: "experienceViewed"; experienceViewed: SellCategory_ExperienceViewedEvent }
    | { $case: "signedContract"; signedContract: SellCategory_SignedContractEvent }
    | { $case: "productClosed"; productClosed: SellCategory_ProductClosedEvent }
    | undefined;
}

export enum SellCategory_SSVATaskType {
  UNKNOWN_SSVA_TASK_TYPE = 0,
  UPLOAD_INTERIOR_RECORDING_TASK = 1,
  UPLOAD_FRONTYARD_RECORDING_TASK = 2,
  UPLOAD_BACKYARD_RECORDING_TASK = 3,
  UPLOAD_WHOLE_HOME_RECORDING_TASK = 4,
  QUESTIONNAIRE_TASK = 5,
  SELLER_DISCLOSURE_DOCUMENT_TASK = 6,
  UNRECOGNIZED = -1,
}

export function sellCategory_SSVATaskTypeFromJSON(object: any): SellCategory_SSVATaskType {
  switch (object) {
    case 0:
    case "UNKNOWN_SSVA_TASK_TYPE":
      return SellCategory_SSVATaskType.UNKNOWN_SSVA_TASK_TYPE;
    case 1:
    case "UPLOAD_INTERIOR_RECORDING_TASK":
      return SellCategory_SSVATaskType.UPLOAD_INTERIOR_RECORDING_TASK;
    case 2:
    case "UPLOAD_FRONTYARD_RECORDING_TASK":
      return SellCategory_SSVATaskType.UPLOAD_FRONTYARD_RECORDING_TASK;
    case 3:
    case "UPLOAD_BACKYARD_RECORDING_TASK":
      return SellCategory_SSVATaskType.UPLOAD_BACKYARD_RECORDING_TASK;
    case 4:
    case "UPLOAD_WHOLE_HOME_RECORDING_TASK":
      return SellCategory_SSVATaskType.UPLOAD_WHOLE_HOME_RECORDING_TASK;
    case 5:
    case "QUESTIONNAIRE_TASK":
      return SellCategory_SSVATaskType.QUESTIONNAIRE_TASK;
    case 6:
    case "SELLER_DISCLOSURE_DOCUMENT_TASK":
      return SellCategory_SSVATaskType.SELLER_DISCLOSURE_DOCUMENT_TASK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SellCategory_SSVATaskType.UNRECOGNIZED;
  }
}

export function sellCategory_SSVATaskTypeToJSON(object: SellCategory_SSVATaskType): string {
  switch (object) {
    case SellCategory_SSVATaskType.UNKNOWN_SSVA_TASK_TYPE:
      return "UNKNOWN_SSVA_TASK_TYPE";
    case SellCategory_SSVATaskType.UPLOAD_INTERIOR_RECORDING_TASK:
      return "UPLOAD_INTERIOR_RECORDING_TASK";
    case SellCategory_SSVATaskType.UPLOAD_FRONTYARD_RECORDING_TASK:
      return "UPLOAD_FRONTYARD_RECORDING_TASK";
    case SellCategory_SSVATaskType.UPLOAD_BACKYARD_RECORDING_TASK:
      return "UPLOAD_BACKYARD_RECORDING_TASK";
    case SellCategory_SSVATaskType.UPLOAD_WHOLE_HOME_RECORDING_TASK:
      return "UPLOAD_WHOLE_HOME_RECORDING_TASK";
    case SellCategory_SSVATaskType.QUESTIONNAIRE_TASK:
      return "QUESTIONNAIRE_TASK";
    case SellCategory_SSVATaskType.SELLER_DISCLOSURE_DOCUMENT_TASK:
      return "SELLER_DISCLOSURE_DOCUMENT_TASK";
    case SellCategory_SSVATaskType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum SellCategory_ProductIntentType {
  UNKNOWN_TYPE = 0,
  LIST = 1,
  /** @deprecated */
  MARKETPLACE = 2,
  SELL_DIRECT = 3,
  UNRECOGNIZED = -1,
}

export function sellCategory_ProductIntentTypeFromJSON(object: any): SellCategory_ProductIntentType {
  switch (object) {
    case 0:
    case "UNKNOWN_TYPE":
      return SellCategory_ProductIntentType.UNKNOWN_TYPE;
    case 1:
    case "LIST":
      return SellCategory_ProductIntentType.LIST;
    case 2:
    case "MARKETPLACE":
      return SellCategory_ProductIntentType.MARKETPLACE;
    case 3:
    case "SELL_DIRECT":
      return SellCategory_ProductIntentType.SELL_DIRECT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SellCategory_ProductIntentType.UNRECOGNIZED;
  }
}

export function sellCategory_ProductIntentTypeToJSON(object: SellCategory_ProductIntentType): string {
  switch (object) {
    case SellCategory_ProductIntentType.UNKNOWN_TYPE:
      return "UNKNOWN_TYPE";
    case SellCategory_ProductIntentType.LIST:
      return "LIST";
    case SellCategory_ProductIntentType.MARKETPLACE:
      return "MARKETPLACE";
    case SellCategory_ProductIntentType.SELL_DIRECT:
      return "SELL_DIRECT";
    case SellCategory_ProductIntentType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Next ID: 13 */
export interface SellCategory_AddressEntryEvent {
  /**
   * Fields match IAddressInputAddress
   * https://github.com/opendoor-labs/code/blob/c393c8d0061e9a8ce32c63621d3ec1ded9fa55ca/js/packages/cinderblocks/src/growth/AddressInput/AddressInput.tsx#L19
   */
  street1: string;
  city: string;
  state: string;
  postalCode: string;
  unit?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  receptionChannel: SellerInput_Channel;
  sellerInputId: string;
  market: string;
  campaign?: string | undefined;
}

/** Next ID: 11 */
export interface SellCategory_OnboardingStartEvent {
  street1: string;
  city: string;
  state: string;
  postalCode: string;
  unit?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  receptionChannel: SellerInput_Channel;
  sellerInputUuid: string;
  market?: string | undefined;
}

/** Next ID: 11 */
export interface SellCategory_AddressEntryV2Event {
  street1?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  postalCode?: string | undefined;
  unit?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  market?: string | undefined;
  campaign?: string | undefined;
  sourcePage?: string | undefined;
}

/** Next ID: 5 */
export interface SellCategory_ApiOfferRequestEvent {
  sellerInputId: string;
  partnerIdentifier: string;
  email: string;
  correlationId?: string | undefined;
}

/** Next ID: 7 */
export interface SellCategory_ApiReferralHandoverEvent {
  sellerInputId: string;
  partnerIdentifier: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email: string;
  phone?: string | undefined;
}

export interface SellCategory_SSVATaskCompleteEvent {
  /** @deprecated */
  leadId: string;
  offerId: string;
  ssvaTaskName: SellCategory_SSVATaskType;
  offerUuid: string;
  sellerLeadUuid: string;
}

/** Track the s3w intent for each lead at FO */
export interface SellCategory_CustomerProductIntentAtFinalOffer {
  /** @deprecated */
  leadId: string;
  intent: SellCategory_ProductIntentType;
  offerUuid: string;
  sellerLeadUuid: string;
}

/** Track the s3w intent for each lead after FO */
export interface SellCategory_CustomerProductIntentPostFinalOffer {
  /** @deprecated */
  leadId: string;
  intent: SellCategory_ProductIntentType;
  offerUuid: string;
  sellerLeadUuid: string;
}

/** Triggered when a seller views a sell experience page */
export interface SellCategory_ExperienceViewedEvent {
  sellerLeadUuid: string;
  offerUuid: string;
  isFirstOffer: boolean;
  offerState: Offer_State;
  experienceType: SellerExperience;
  /** Optional: specific page design slug for tracking */
  experienceSlug?: string | undefined;
}

/**
 * Triggered when a seller signs a contract (PA for Cash/Cash Plus, Listing Agreement for LWC)
 * Next ID: 4
 */
export interface SellCategory_SignedContractEvent {
  sellerLeadUuid: string;
  /** Nullable: not present for LWC */
  offerUuid?: string | undefined;
  product: Product;
}

/**
 * Triggered when a product transaction closes
 * Next ID: 4
 */
export interface SellCategory_ProductClosedEvent {
  sellerLeadUuid: string;
  /** Nullable: not present for LWC */
  offerUuid?: string | undefined;
  product: Product;
}

function createBaseSellCategory(): SellCategory {
  return { event: undefined };
}

export const SellCategory = {
  fromJSON(object: any): SellCategory {
    return {
      event: isSet(object.addressEntry)
        ? { $case: "addressEntry", addressEntry: SellCategory_AddressEntryEvent.fromJSON(object.addressEntry) }
        : isSet(object.apiOfferRequest)
        ? {
          $case: "apiOfferRequest",
          apiOfferRequest: SellCategory_ApiOfferRequestEvent.fromJSON(object.apiOfferRequest),
        }
        : isSet(object.apiReferralHandover)
        ? {
          $case: "apiReferralHandover",
          apiReferralHandover: SellCategory_ApiReferralHandoverEvent.fromJSON(object.apiReferralHandover),
        }
        : isSet(object.onboardingStart)
        ? {
          $case: "onboardingStart",
          onboardingStart: SellCategory_OnboardingStartEvent.fromJSON(object.onboardingStart),
        }
        : isSet(object.addressEntryV2)
        ? { $case: "addressEntryV2", addressEntryV2: SellCategory_AddressEntryV2Event.fromJSON(object.addressEntryV2) }
        : isSet(object.ssvaTaskComplete)
        ? {
          $case: "ssvaTaskComplete",
          ssvaTaskComplete: SellCategory_SSVATaskCompleteEvent.fromJSON(object.ssvaTaskComplete),
        }
        : isSet(object.customerProductIntentAtFinalOffer)
        ? {
          $case: "customerProductIntentAtFinalOffer",
          customerProductIntentAtFinalOffer: SellCategory_CustomerProductIntentAtFinalOffer.fromJSON(
            object.customerProductIntentAtFinalOffer,
          ),
        }
        : isSet(object.customerProductIntentPostFinalOffer)
        ? {
          $case: "customerProductIntentPostFinalOffer",
          customerProductIntentPostFinalOffer: SellCategory_CustomerProductIntentPostFinalOffer.fromJSON(
            object.customerProductIntentPostFinalOffer,
          ),
        }
        : isSet(object.experienceViewed)
        ? {
          $case: "experienceViewed",
          experienceViewed: SellCategory_ExperienceViewedEvent.fromJSON(object.experienceViewed),
        }
        : isSet(object.signedContract)
        ? { $case: "signedContract", signedContract: SellCategory_SignedContractEvent.fromJSON(object.signedContract) }
        : isSet(object.productClosed)
        ? { $case: "productClosed", productClosed: SellCategory_ProductClosedEvent.fromJSON(object.productClosed) }
        : undefined,
    };
  },

  toJSON(message: SellCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "addressEntry") {
      obj.addressEntry = SellCategory_AddressEntryEvent.toJSON(message.event.addressEntry);
    }
    if (message.event?.$case === "apiOfferRequest") {
      obj.apiOfferRequest = SellCategory_ApiOfferRequestEvent.toJSON(message.event.apiOfferRequest);
    }
    if (message.event?.$case === "apiReferralHandover") {
      obj.apiReferralHandover = SellCategory_ApiReferralHandoverEvent.toJSON(message.event.apiReferralHandover);
    }
    if (message.event?.$case === "onboardingStart") {
      obj.onboardingStart = SellCategory_OnboardingStartEvent.toJSON(message.event.onboardingStart);
    }
    if (message.event?.$case === "addressEntryV2") {
      obj.addressEntryV2 = SellCategory_AddressEntryV2Event.toJSON(message.event.addressEntryV2);
    }
    if (message.event?.$case === "ssvaTaskComplete") {
      obj.ssvaTaskComplete = SellCategory_SSVATaskCompleteEvent.toJSON(message.event.ssvaTaskComplete);
    }
    if (message.event?.$case === "customerProductIntentAtFinalOffer") {
      obj.customerProductIntentAtFinalOffer = SellCategory_CustomerProductIntentAtFinalOffer.toJSON(
        message.event.customerProductIntentAtFinalOffer,
      );
    }
    if (message.event?.$case === "customerProductIntentPostFinalOffer") {
      obj.customerProductIntentPostFinalOffer = SellCategory_CustomerProductIntentPostFinalOffer.toJSON(
        message.event.customerProductIntentPostFinalOffer,
      );
    }
    if (message.event?.$case === "experienceViewed") {
      obj.experienceViewed = SellCategory_ExperienceViewedEvent.toJSON(message.event.experienceViewed);
    }
    if (message.event?.$case === "signedContract") {
      obj.signedContract = SellCategory_SignedContractEvent.toJSON(message.event.signedContract);
    }
    if (message.event?.$case === "productClosed") {
      obj.productClosed = SellCategory_ProductClosedEvent.toJSON(message.event.productClosed);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory>, I>>(base?: I): SellCategory {
    return SellCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory>, I>>(object: I): SellCategory {
    const message = createBaseSellCategory();
    if (
      object.event?.$case === "addressEntry" &&
      object.event?.addressEntry !== undefined &&
      object.event?.addressEntry !== null
    ) {
      message.event = {
        $case: "addressEntry",
        addressEntry: SellCategory_AddressEntryEvent.fromPartial(object.event.addressEntry),
      };
    }
    if (
      object.event?.$case === "apiOfferRequest" &&
      object.event?.apiOfferRequest !== undefined &&
      object.event?.apiOfferRequest !== null
    ) {
      message.event = {
        $case: "apiOfferRequest",
        apiOfferRequest: SellCategory_ApiOfferRequestEvent.fromPartial(object.event.apiOfferRequest),
      };
    }
    if (
      object.event?.$case === "apiReferralHandover" &&
      object.event?.apiReferralHandover !== undefined &&
      object.event?.apiReferralHandover !== null
    ) {
      message.event = {
        $case: "apiReferralHandover",
        apiReferralHandover: SellCategory_ApiReferralHandoverEvent.fromPartial(object.event.apiReferralHandover),
      };
    }
    if (
      object.event?.$case === "onboardingStart" &&
      object.event?.onboardingStart !== undefined &&
      object.event?.onboardingStart !== null
    ) {
      message.event = {
        $case: "onboardingStart",
        onboardingStart: SellCategory_OnboardingStartEvent.fromPartial(object.event.onboardingStart),
      };
    }
    if (
      object.event?.$case === "addressEntryV2" &&
      object.event?.addressEntryV2 !== undefined &&
      object.event?.addressEntryV2 !== null
    ) {
      message.event = {
        $case: "addressEntryV2",
        addressEntryV2: SellCategory_AddressEntryV2Event.fromPartial(object.event.addressEntryV2),
      };
    }
    if (
      object.event?.$case === "ssvaTaskComplete" &&
      object.event?.ssvaTaskComplete !== undefined &&
      object.event?.ssvaTaskComplete !== null
    ) {
      message.event = {
        $case: "ssvaTaskComplete",
        ssvaTaskComplete: SellCategory_SSVATaskCompleteEvent.fromPartial(object.event.ssvaTaskComplete),
      };
    }
    if (
      object.event?.$case === "customerProductIntentAtFinalOffer" &&
      object.event?.customerProductIntentAtFinalOffer !== undefined &&
      object.event?.customerProductIntentAtFinalOffer !== null
    ) {
      message.event = {
        $case: "customerProductIntentAtFinalOffer",
        customerProductIntentAtFinalOffer: SellCategory_CustomerProductIntentAtFinalOffer.fromPartial(
          object.event.customerProductIntentAtFinalOffer,
        ),
      };
    }
    if (
      object.event?.$case === "customerProductIntentPostFinalOffer" &&
      object.event?.customerProductIntentPostFinalOffer !== undefined &&
      object.event?.customerProductIntentPostFinalOffer !== null
    ) {
      message.event = {
        $case: "customerProductIntentPostFinalOffer",
        customerProductIntentPostFinalOffer: SellCategory_CustomerProductIntentPostFinalOffer.fromPartial(
          object.event.customerProductIntentPostFinalOffer,
        ),
      };
    }
    if (
      object.event?.$case === "experienceViewed" &&
      object.event?.experienceViewed !== undefined &&
      object.event?.experienceViewed !== null
    ) {
      message.event = {
        $case: "experienceViewed",
        experienceViewed: SellCategory_ExperienceViewedEvent.fromPartial(object.event.experienceViewed),
      };
    }
    if (
      object.event?.$case === "signedContract" &&
      object.event?.signedContract !== undefined &&
      object.event?.signedContract !== null
    ) {
      message.event = {
        $case: "signedContract",
        signedContract: SellCategory_SignedContractEvent.fromPartial(object.event.signedContract),
      };
    }
    if (
      object.event?.$case === "productClosed" &&
      object.event?.productClosed !== undefined &&
      object.event?.productClosed !== null
    ) {
      message.event = {
        $case: "productClosed",
        productClosed: SellCategory_ProductClosedEvent.fromPartial(object.event.productClosed),
      };
    }
    return message;
  },
};

function createBaseSellCategory_AddressEntryEvent(): SellCategory_AddressEntryEvent {
  return {
    street1: "",
    city: "",
    state: "",
    postalCode: "",
    unit: undefined,
    latitude: undefined,
    longitude: undefined,
    receptionChannel: 0,
    sellerInputId: "",
    market: "",
    campaign: undefined,
  };
}

export const SellCategory_AddressEntryEvent = {
  fromJSON(object: any): SellCategory_AddressEntryEvent {
    return {
      street1: isSet(object.street1) ? String(object.street1) : "",
      city: isSet(object.city) ? String(object.city) : "",
      state: isSet(object.state) ? String(object.state) : "",
      postalCode: isSet(object.postalCode) ? String(object.postalCode) : "",
      unit: isSet(object.unit) ? String(object.unit) : undefined,
      latitude: isSet(object.latitude) ? Number(object.latitude) : undefined,
      longitude: isSet(object.longitude) ? Number(object.longitude) : undefined,
      receptionChannel: isSet(object.receptionChannel) ? sellerInput_ChannelFromJSON(object.receptionChannel) : 0,
      sellerInputId: isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
      market: isSet(object.market) ? String(object.market) : "",
      campaign: isSet(object.campaign) ? String(object.campaign) : undefined,
    };
  },

  toJSON(message: SellCategory_AddressEntryEvent): unknown {
    const obj: any = {};
    if (message.street1 !== "") {
      obj.street1 = message.street1;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.postalCode !== "") {
      obj.postalCode = message.postalCode;
    }
    if (message.unit !== undefined) {
      obj.unit = message.unit;
    }
    if (message.latitude !== undefined) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== undefined) {
      obj.longitude = message.longitude;
    }
    if (message.receptionChannel !== 0) {
      obj.receptionChannel = sellerInput_ChannelToJSON(message.receptionChannel);
    }
    if (message.sellerInputId !== "") {
      obj.sellerInputId = message.sellerInputId;
    }
    if (message.market !== "") {
      obj.market = message.market;
    }
    if (message.campaign !== undefined) {
      obj.campaign = message.campaign;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_AddressEntryEvent>, I>>(base?: I): SellCategory_AddressEntryEvent {
    return SellCategory_AddressEntryEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_AddressEntryEvent>, I>>(
    object: I,
  ): SellCategory_AddressEntryEvent {
    const message = createBaseSellCategory_AddressEntryEvent();
    message.street1 = object.street1 ?? "";
    message.city = object.city ?? "";
    message.state = object.state ?? "";
    message.postalCode = object.postalCode ?? "";
    message.unit = object.unit ?? undefined;
    message.latitude = object.latitude ?? undefined;
    message.longitude = object.longitude ?? undefined;
    message.receptionChannel = object.receptionChannel ?? 0;
    message.sellerInputId = object.sellerInputId ?? "";
    message.market = object.market ?? "";
    message.campaign = object.campaign ?? undefined;
    return message;
  },
};

function createBaseSellCategory_OnboardingStartEvent(): SellCategory_OnboardingStartEvent {
  return {
    street1: "",
    city: "",
    state: "",
    postalCode: "",
    unit: undefined,
    latitude: undefined,
    longitude: undefined,
    receptionChannel: 0,
    sellerInputUuid: "",
    market: undefined,
  };
}

export const SellCategory_OnboardingStartEvent = {
  fromJSON(object: any): SellCategory_OnboardingStartEvent {
    return {
      street1: isSet(object.street1) ? String(object.street1) : "",
      city: isSet(object.city) ? String(object.city) : "",
      state: isSet(object.state) ? String(object.state) : "",
      postalCode: isSet(object.postalCode) ? String(object.postalCode) : "",
      unit: isSet(object.unit) ? String(object.unit) : undefined,
      latitude: isSet(object.latitude) ? Number(object.latitude) : undefined,
      longitude: isSet(object.longitude) ? Number(object.longitude) : undefined,
      receptionChannel: isSet(object.receptionChannel) ? sellerInput_ChannelFromJSON(object.receptionChannel) : 0,
      sellerInputUuid: isSet(object.sellerInputUuid) ? String(object.sellerInputUuid) : "",
      market: isSet(object.market) ? String(object.market) : undefined,
    };
  },

  toJSON(message: SellCategory_OnboardingStartEvent): unknown {
    const obj: any = {};
    if (message.street1 !== "") {
      obj.street1 = message.street1;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.state !== "") {
      obj.state = message.state;
    }
    if (message.postalCode !== "") {
      obj.postalCode = message.postalCode;
    }
    if (message.unit !== undefined) {
      obj.unit = message.unit;
    }
    if (message.latitude !== undefined) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== undefined) {
      obj.longitude = message.longitude;
    }
    if (message.receptionChannel !== 0) {
      obj.receptionChannel = sellerInput_ChannelToJSON(message.receptionChannel);
    }
    if (message.sellerInputUuid !== "") {
      obj.sellerInputUuid = message.sellerInputUuid;
    }
    if (message.market !== undefined) {
      obj.market = message.market;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_OnboardingStartEvent>, I>>(
    base?: I,
  ): SellCategory_OnboardingStartEvent {
    return SellCategory_OnboardingStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_OnboardingStartEvent>, I>>(
    object: I,
  ): SellCategory_OnboardingStartEvent {
    const message = createBaseSellCategory_OnboardingStartEvent();
    message.street1 = object.street1 ?? "";
    message.city = object.city ?? "";
    message.state = object.state ?? "";
    message.postalCode = object.postalCode ?? "";
    message.unit = object.unit ?? undefined;
    message.latitude = object.latitude ?? undefined;
    message.longitude = object.longitude ?? undefined;
    message.receptionChannel = object.receptionChannel ?? 0;
    message.sellerInputUuid = object.sellerInputUuid ?? "";
    message.market = object.market ?? undefined;
    return message;
  },
};

function createBaseSellCategory_AddressEntryV2Event(): SellCategory_AddressEntryV2Event {
  return {
    street1: undefined,
    city: undefined,
    state: undefined,
    postalCode: undefined,
    unit: undefined,
    latitude: undefined,
    longitude: undefined,
    market: undefined,
    campaign: undefined,
    sourcePage: undefined,
  };
}

export const SellCategory_AddressEntryV2Event = {
  fromJSON(object: any): SellCategory_AddressEntryV2Event {
    return {
      street1: isSet(object.street1) ? String(object.street1) : undefined,
      city: isSet(object.city) ? String(object.city) : undefined,
      state: isSet(object.state) ? String(object.state) : undefined,
      postalCode: isSet(object.postalCode) ? String(object.postalCode) : undefined,
      unit: isSet(object.unit) ? String(object.unit) : undefined,
      latitude: isSet(object.latitude) ? Number(object.latitude) : undefined,
      longitude: isSet(object.longitude) ? Number(object.longitude) : undefined,
      market: isSet(object.market) ? String(object.market) : undefined,
      campaign: isSet(object.campaign) ? String(object.campaign) : undefined,
      sourcePage: isSet(object.sourcePage) ? String(object.sourcePage) : undefined,
    };
  },

  toJSON(message: SellCategory_AddressEntryV2Event): unknown {
    const obj: any = {};
    if (message.street1 !== undefined) {
      obj.street1 = message.street1;
    }
    if (message.city !== undefined) {
      obj.city = message.city;
    }
    if (message.state !== undefined) {
      obj.state = message.state;
    }
    if (message.postalCode !== undefined) {
      obj.postalCode = message.postalCode;
    }
    if (message.unit !== undefined) {
      obj.unit = message.unit;
    }
    if (message.latitude !== undefined) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== undefined) {
      obj.longitude = message.longitude;
    }
    if (message.market !== undefined) {
      obj.market = message.market;
    }
    if (message.campaign !== undefined) {
      obj.campaign = message.campaign;
    }
    if (message.sourcePage !== undefined) {
      obj.sourcePage = message.sourcePage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_AddressEntryV2Event>, I>>(
    base?: I,
  ): SellCategory_AddressEntryV2Event {
    return SellCategory_AddressEntryV2Event.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_AddressEntryV2Event>, I>>(
    object: I,
  ): SellCategory_AddressEntryV2Event {
    const message = createBaseSellCategory_AddressEntryV2Event();
    message.street1 = object.street1 ?? undefined;
    message.city = object.city ?? undefined;
    message.state = object.state ?? undefined;
    message.postalCode = object.postalCode ?? undefined;
    message.unit = object.unit ?? undefined;
    message.latitude = object.latitude ?? undefined;
    message.longitude = object.longitude ?? undefined;
    message.market = object.market ?? undefined;
    message.campaign = object.campaign ?? undefined;
    message.sourcePage = object.sourcePage ?? undefined;
    return message;
  },
};

function createBaseSellCategory_ApiOfferRequestEvent(): SellCategory_ApiOfferRequestEvent {
  return { sellerInputId: "", partnerIdentifier: "", email: "", correlationId: undefined };
}

export const SellCategory_ApiOfferRequestEvent = {
  fromJSON(object: any): SellCategory_ApiOfferRequestEvent {
    return {
      sellerInputId: isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
      partnerIdentifier: isSet(object.partnerIdentifier) ? String(object.partnerIdentifier) : "",
      email: isSet(object.email) ? String(object.email) : "",
      correlationId: isSet(object.correlationId) ? String(object.correlationId) : undefined,
    };
  },

  toJSON(message: SellCategory_ApiOfferRequestEvent): unknown {
    const obj: any = {};
    if (message.sellerInputId !== "") {
      obj.sellerInputId = message.sellerInputId;
    }
    if (message.partnerIdentifier !== "") {
      obj.partnerIdentifier = message.partnerIdentifier;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.correlationId !== undefined) {
      obj.correlationId = message.correlationId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_ApiOfferRequestEvent>, I>>(
    base?: I,
  ): SellCategory_ApiOfferRequestEvent {
    return SellCategory_ApiOfferRequestEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_ApiOfferRequestEvent>, I>>(
    object: I,
  ): SellCategory_ApiOfferRequestEvent {
    const message = createBaseSellCategory_ApiOfferRequestEvent();
    message.sellerInputId = object.sellerInputId ?? "";
    message.partnerIdentifier = object.partnerIdentifier ?? "";
    message.email = object.email ?? "";
    message.correlationId = object.correlationId ?? undefined;
    return message;
  },
};

function createBaseSellCategory_ApiReferralHandoverEvent(): SellCategory_ApiReferralHandoverEvent {
  return {
    sellerInputId: "",
    partnerIdentifier: "",
    firstName: undefined,
    lastName: undefined,
    email: "",
    phone: undefined,
  };
}

export const SellCategory_ApiReferralHandoverEvent = {
  fromJSON(object: any): SellCategory_ApiReferralHandoverEvent {
    return {
      sellerInputId: isSet(object.sellerInputId) ? String(object.sellerInputId) : "",
      partnerIdentifier: isSet(object.partnerIdentifier) ? String(object.partnerIdentifier) : "",
      firstName: isSet(object.firstName) ? String(object.firstName) : undefined,
      lastName: isSet(object.lastName) ? String(object.lastName) : undefined,
      email: isSet(object.email) ? String(object.email) : "",
      phone: isSet(object.phone) ? String(object.phone) : undefined,
    };
  },

  toJSON(message: SellCategory_ApiReferralHandoverEvent): unknown {
    const obj: any = {};
    if (message.sellerInputId !== "") {
      obj.sellerInputId = message.sellerInputId;
    }
    if (message.partnerIdentifier !== "") {
      obj.partnerIdentifier = message.partnerIdentifier;
    }
    if (message.firstName !== undefined) {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== undefined) {
      obj.lastName = message.lastName;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.phone !== undefined) {
      obj.phone = message.phone;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_ApiReferralHandoverEvent>, I>>(
    base?: I,
  ): SellCategory_ApiReferralHandoverEvent {
    return SellCategory_ApiReferralHandoverEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_ApiReferralHandoverEvent>, I>>(
    object: I,
  ): SellCategory_ApiReferralHandoverEvent {
    const message = createBaseSellCategory_ApiReferralHandoverEvent();
    message.sellerInputId = object.sellerInputId ?? "";
    message.partnerIdentifier = object.partnerIdentifier ?? "";
    message.firstName = object.firstName ?? undefined;
    message.lastName = object.lastName ?? undefined;
    message.email = object.email ?? "";
    message.phone = object.phone ?? undefined;
    return message;
  },
};

function createBaseSellCategory_SSVATaskCompleteEvent(): SellCategory_SSVATaskCompleteEvent {
  return { leadId: "", offerId: "", ssvaTaskName: 0, offerUuid: "", sellerLeadUuid: "" };
}

export const SellCategory_SSVATaskCompleteEvent = {
  fromJSON(object: any): SellCategory_SSVATaskCompleteEvent {
    return {
      leadId: isSet(object.leadId) ? String(object.leadId) : "",
      offerId: isSet(object.offerId) ? String(object.offerId) : "",
      ssvaTaskName: isSet(object.ssvaTaskName) ? sellCategory_SSVATaskTypeFromJSON(object.ssvaTaskName) : 0,
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
    };
  },

  toJSON(message: SellCategory_SSVATaskCompleteEvent): unknown {
    const obj: any = {};
    if (message.leadId !== "") {
      obj.leadId = message.leadId;
    }
    if (message.offerId !== "") {
      obj.offerId = message.offerId;
    }
    if (message.ssvaTaskName !== 0) {
      obj.ssvaTaskName = sellCategory_SSVATaskTypeToJSON(message.ssvaTaskName);
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_SSVATaskCompleteEvent>, I>>(
    base?: I,
  ): SellCategory_SSVATaskCompleteEvent {
    return SellCategory_SSVATaskCompleteEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_SSVATaskCompleteEvent>, I>>(
    object: I,
  ): SellCategory_SSVATaskCompleteEvent {
    const message = createBaseSellCategory_SSVATaskCompleteEvent();
    message.leadId = object.leadId ?? "";
    message.offerId = object.offerId ?? "";
    message.ssvaTaskName = object.ssvaTaskName ?? 0;
    message.offerUuid = object.offerUuid ?? "";
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    return message;
  },
};

function createBaseSellCategory_CustomerProductIntentAtFinalOffer(): SellCategory_CustomerProductIntentAtFinalOffer {
  return { leadId: "", intent: 0, offerUuid: "", sellerLeadUuid: "" };
}

export const SellCategory_CustomerProductIntentAtFinalOffer = {
  fromJSON(object: any): SellCategory_CustomerProductIntentAtFinalOffer {
    return {
      leadId: isSet(object.leadId) ? String(object.leadId) : "",
      intent: isSet(object.intent) ? sellCategory_ProductIntentTypeFromJSON(object.intent) : 0,
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
    };
  },

  toJSON(message: SellCategory_CustomerProductIntentAtFinalOffer): unknown {
    const obj: any = {};
    if (message.leadId !== "") {
      obj.leadId = message.leadId;
    }
    if (message.intent !== 0) {
      obj.intent = sellCategory_ProductIntentTypeToJSON(message.intent);
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_CustomerProductIntentAtFinalOffer>, I>>(
    base?: I,
  ): SellCategory_CustomerProductIntentAtFinalOffer {
    return SellCategory_CustomerProductIntentAtFinalOffer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_CustomerProductIntentAtFinalOffer>, I>>(
    object: I,
  ): SellCategory_CustomerProductIntentAtFinalOffer {
    const message = createBaseSellCategory_CustomerProductIntentAtFinalOffer();
    message.leadId = object.leadId ?? "";
    message.intent = object.intent ?? 0;
    message.offerUuid = object.offerUuid ?? "";
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    return message;
  },
};

function createBaseSellCategory_CustomerProductIntentPostFinalOffer(): SellCategory_CustomerProductIntentPostFinalOffer {
  return { leadId: "", intent: 0, offerUuid: "", sellerLeadUuid: "" };
}

export const SellCategory_CustomerProductIntentPostFinalOffer = {
  fromJSON(object: any): SellCategory_CustomerProductIntentPostFinalOffer {
    return {
      leadId: isSet(object.leadId) ? String(object.leadId) : "",
      intent: isSet(object.intent) ? sellCategory_ProductIntentTypeFromJSON(object.intent) : 0,
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
    };
  },

  toJSON(message: SellCategory_CustomerProductIntentPostFinalOffer): unknown {
    const obj: any = {};
    if (message.leadId !== "") {
      obj.leadId = message.leadId;
    }
    if (message.intent !== 0) {
      obj.intent = sellCategory_ProductIntentTypeToJSON(message.intent);
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_CustomerProductIntentPostFinalOffer>, I>>(
    base?: I,
  ): SellCategory_CustomerProductIntentPostFinalOffer {
    return SellCategory_CustomerProductIntentPostFinalOffer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_CustomerProductIntentPostFinalOffer>, I>>(
    object: I,
  ): SellCategory_CustomerProductIntentPostFinalOffer {
    const message = createBaseSellCategory_CustomerProductIntentPostFinalOffer();
    message.leadId = object.leadId ?? "";
    message.intent = object.intent ?? 0;
    message.offerUuid = object.offerUuid ?? "";
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    return message;
  },
};

function createBaseSellCategory_ExperienceViewedEvent(): SellCategory_ExperienceViewedEvent {
  return {
    sellerLeadUuid: "",
    offerUuid: "",
    isFirstOffer: false,
    offerState: 0,
    experienceType: 0,
    experienceSlug: undefined,
  };
}

export const SellCategory_ExperienceViewedEvent = {
  fromJSON(object: any): SellCategory_ExperienceViewedEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      isFirstOffer: isSet(object.isFirstOffer) ? Boolean(object.isFirstOffer) : false,
      offerState: isSet(object.offerState) ? offer_StateFromJSON(object.offerState) : 0,
      experienceType: isSet(object.experienceType) ? sellerExperienceFromJSON(object.experienceType) : 0,
      experienceSlug: isSet(object.experienceSlug) ? String(object.experienceSlug) : undefined,
    };
  },

  toJSON(message: SellCategory_ExperienceViewedEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.isFirstOffer === true) {
      obj.isFirstOffer = message.isFirstOffer;
    }
    if (message.offerState !== 0) {
      obj.offerState = offer_StateToJSON(message.offerState);
    }
    if (message.experienceType !== 0) {
      obj.experienceType = sellerExperienceToJSON(message.experienceType);
    }
    if (message.experienceSlug !== undefined) {
      obj.experienceSlug = message.experienceSlug;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_ExperienceViewedEvent>, I>>(
    base?: I,
  ): SellCategory_ExperienceViewedEvent {
    return SellCategory_ExperienceViewedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_ExperienceViewedEvent>, I>>(
    object: I,
  ): SellCategory_ExperienceViewedEvent {
    const message = createBaseSellCategory_ExperienceViewedEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.isFirstOffer = object.isFirstOffer ?? false;
    message.offerState = object.offerState ?? 0;
    message.experienceType = object.experienceType ?? 0;
    message.experienceSlug = object.experienceSlug ?? undefined;
    return message;
  },
};

function createBaseSellCategory_SignedContractEvent(): SellCategory_SignedContractEvent {
  return { sellerLeadUuid: "", offerUuid: undefined, product: 0 };
}

export const SellCategory_SignedContractEvent = {
  fromJSON(object: any): SellCategory_SignedContractEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : undefined,
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
    };
  },

  toJSON(message: SellCategory_SignedContractEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== undefined) {
      obj.offerUuid = message.offerUuid;
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_SignedContractEvent>, I>>(
    base?: I,
  ): SellCategory_SignedContractEvent {
    return SellCategory_SignedContractEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_SignedContractEvent>, I>>(
    object: I,
  ): SellCategory_SignedContractEvent {
    const message = createBaseSellCategory_SignedContractEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? undefined;
    message.product = object.product ?? 0;
    return message;
  },
};

function createBaseSellCategory_ProductClosedEvent(): SellCategory_ProductClosedEvent {
  return { sellerLeadUuid: "", offerUuid: undefined, product: 0 };
}

export const SellCategory_ProductClosedEvent = {
  fromJSON(object: any): SellCategory_ProductClosedEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : undefined,
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
    };
  },

  toJSON(message: SellCategory_ProductClosedEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== undefined) {
      obj.offerUuid = message.offerUuid;
    }
    if (message.product !== 0) {
      obj.product = productToJSON(message.product);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SellCategory_ProductClosedEvent>, I>>(base?: I): SellCategory_ProductClosedEvent {
    return SellCategory_ProductClosedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SellCategory_ProductClosedEvent>, I>>(
    object: I,
  ): SellCategory_ProductClosedEvent {
    const message = createBaseSellCategory_ProductClosedEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? undefined;
    message.product = object.product ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
